import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import { InitService } from '@services';
import { PrivateLayout, PublicLayout, WithSuspense } from '@hocs';
import { useSocket } from '@hooks';
import { Loader, Modals, Popups, Snackbars } from '@components';
import { MetaPage } from '@elements';
import 'react-reflex/styles.css';
import { appSocket } from './app.socket';
import { appPrivateRoutes, appPublicRoutes } from './routers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var AppComponent = function AppComponent() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isAppReady = _useState2[0],
      setIsAppReady = _useState2[1];

  useSocket(appSocket, []);

  var hideSplashScreen = function hideSplashScreen() {
    var loader = document.getElementById('loader');

    if (loader) {
      window.appReady = true;
      setTimeout(function () {
        document.body.classList.remove('loading');
        setTimeout(function () {
          loader.style.visibility = 'hidden';
          loader.remove();
        }, 180);
      }, 200);
    }
  };

  useEffect(function () {
    InitService.init().then(function () {
      setIsAppReady(true);
      hideSplashScreen();
    })["catch"](function () {
      setIsAppReady(true);
      hideSplashScreen();
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Loader, {}), /*#__PURE__*/_jsx(MetaPage, {}), isAppReady ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Routes, {
        children: [appPrivateRoutes.map(function (route) {
          var _route$children;

          return /*#__PURE__*/_jsx(Route, {
            path: "/",
            element: /*#__PURE__*/_jsx(PrivateLayout, {
              inline: route.inline
            }),
            children: /*#__PURE__*/_jsx(Route, {
              path: route.path,
              element: WithSuspense(route.element),
              index: route.index,
              children: !!(route !== null && route !== void 0 && (_route$children = route.children) !== null && _route$children !== void 0 && _route$children.length) && route.children.map(function (childRoute) {
                return /*#__PURE__*/_jsx(Route, {
                  path: childRoute.path,
                  element: WithSuspense(childRoute.element),
                  index: childRoute.index
                }, childRoute.name);
              })
            })
          }, route.name);
        }), appPublicRoutes.map(function (route) {
          return /*#__PURE__*/_jsx(Route, {
            path: "/",
            element: /*#__PURE__*/_jsx(PublicLayout, {
              inline: route.inline
            }),
            children: /*#__PURE__*/_jsx(Route, {
              path: route.path,
              element: WithSuspense(route.element),
              index: route.index
            })
          }, route.name);
        })]
      }), /*#__PURE__*/_jsx(Modals, {}), /*#__PURE__*/_jsx(Popups, {}), /*#__PURE__*/_jsx(Snackbars, {})]
    }) : null]
  });
};

export default withTranslation()(AppComponent);